/*
 * @Author: Shiltin 18580045074@163.com
 * @Date: 2022-08-10 15:31:30
 * @LastEditors: 冉桂精 156189868@qq.com
 * @LastEditTime: 2023-03-14 15:53:17
 * @FilePath: /dataview-viewer-test/src/custom-component/component-config/model.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const modelConsole = {
	type: 'model',
	title: '模型组件',
	show: true,
	order: 8,
	componentList: [
		{
			component: 'ViewerBIM',
			type: 'container',
			name: 'BIM模型',
			icon: 'icon-moxing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: true,
			},
		},
		// {
		// 	component: 'BIMModelList',
		// 	type: 'BIMExtend',
		// 	name: 'BIM模型列表',
		// 	icon: 'icon-moxing',
		// 	isLock: false, // 是否锁定
		// 	needCommonStyle: false,
		// 	propValue: '',
		// 	span: 24,
		// 	statusConfig: {
		// 		displayShow: true,
		// 		isShow: true // 是否显示
		// 	},
		// 	style: {
		// 		height: '200',
		// 		width: '300',
		// 		rotate: 0,
		// 		paddingTop: 0,
		// 		paddingBottom: 0,
		// 		paddingLeft: 0,
		// 		paddingRight: 0
		// 	},
		// 	behaviors: [
		// 	],
		// 	actionConfig:{
		// 		needAction: false,
		// 		width: '',
		// 	},
		// },
		{
			component: 'ViewerGIS',
			type: 'ModelGIS',
			name: 'GIS模型',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
			},
		},
		{
			component: 'viewerBIMModule',
			type: 'container',
			name: '模型功能容器',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
				width: '',
			},
		},
		{
			component: 'viewerBIMModuleModelTree',
			type: 'container',
			name: '模型树',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
				width: '',
			},
		},
		{
			component: 'viewerBIMModuleViewState',
			type: 'container',
			name: '视点列表',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
				width: '',
			},
		},
		{
			component: 'ViewerGISModule',
			type: 'container',
			name: 'GIS功能容器',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
				width: '',
			},
		},
		{
			component: 'ViewerGISModelTree',
			type: 'container',
			name: 'GIS模型树',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
				width: '',
			},
		},
		{
			component: 'ViewerGISViewPoint',
			type: 'container',
			name: 'GIS视点',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
				width: '',
			},
		},
		{
			component: 'ViewerGISKml',
			type: 'container',
			name: 'GISKml',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
				width: '',
			},
		},
		{
			component: 'ViewerGISMeasurePoint',
			type: 'container',
			name: 'GIS测点',
			icon: 'icongis_changjing',
			isLock: false, // 是否锁定
			needCommonStyle: true,
			propValue: '',
			span: 24,
			statusConfig: {
				displayShow: true,
				isShow: true // 是否显示
			},
			style: {
				height: '100%',
				width: '',
				rotate: 0,
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			},
			behaviors: [
			],
			actionConfig:{
				needAction: false,
				width: '',
			},
		}
	]
};

export default modelConsole;
